import { useContext, useEffect, useState } from "react";
import { HorizontalLayout, VerticalLayout } from "../components/layout";
import { deleteAPI, getAPI, postAPI } from "../api/api";
import { ToggleSwitch } from "./ToggleSwitch";
import { Search } from "../atoms/search";
import { ModalButton, StandardButton } from "../atoms/buttons";
import { TitleAtom } from "../atoms/titleAtom";
import { Spinner } from "../atoms/spinner";
import { PageContext, ToastContext, UserContext } from "../App";

export default function DepartmentSelectors() {
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectLoader, setSelectLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const navigationContext = useContext(PageContext);
    const toastContext = useContext(ToastContext);
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1

    const loadDepartments = async () => {
        setLoading(true);
        const query = `api/courses/${navigationContext.sidebar.courseID}/departments`;
        const res = await getAPI(query);
        if (res.status === "ok") {
            const withActive = res.data.map(dep => ({
                ...dep,
                active: dep.active || false
            }));
            setDepartments(withActive);
        } else {
            console.error("Unexpected res format:", res);
        }
        setLoading(false);
    };

    const handleToggleDepartment = async (index) => {
        const updated = [...departments];
        updated[index].active = !updated[index].active;
        setDepartments(updated);

        const dep = updated[index];
        const body = {
            id_course: navigationContext.sidebar.courseID,
            departments: [{ id_setting: dep.id_setting }],
            active: dep.active,
        };

        const query = "api/courses/set-all-department";
        const res = await postAPI(query, body);

        if (res.status === "ok") {
            toastContext.showToast(<>{dep.active ? `${isPublic ? "Doelgroep" : "Afdeling"} geselecteerd!` : `${isPublic ? "Doelgroep" : "Afdeling"} verwijderd!`}</>, "success", 1000);
        } else {
            toastContext.showToast(<>Actie mislukt, probeer opnieuw.</>, "error");
            updated[index].active = !updated[index].active;
            setDepartments(updated);
        }
    };

    useEffect(() => {
        loadDepartments();
    }, []);

    const filteredDepartments = departments.filter((department) =>
        (department.name).toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectedCount = departments.filter(d => d.active).length;
    const allSelected = selectedCount === departments.length
    const toggleAll = async () => {
        setSelectLoading(true);
        const newActive = !allSelected;
        const updated = departments.map(dep => ({ ...dep, active: newActive }));
        setDepartments(updated);
        const body = {
            id_course: navigationContext.sidebar.courseID,
            active: newActive,
            departments: updated 
        }
        const query = "api/courses/set-all-department";
        const res = await postAPI(query, body);
        if (res.status === "ok") {
            toastContext.showToast(<>Alle {isPublic ? "doelgroepen" : "afdelingen"} {newActive ? "geselecteerd" : "gedeselecteerd"}!</>,"success", 1000);
        } else {
            toastContext.showToast(<>Actie mislukt, probeer opnieuw.</>, "error", 1000);
            const rollback = departments.map(dep => ({ ...dep, active: !newActive }));
            setDepartments(rollback);
        }
        setSelectLoading(false);
    };


    return (
        <VerticalLayout>
            <HorizontalLayout>
                <TitleAtom className={"standard-margin"} title={`${isPublic ? "Doelgroepen" : "Afdelingen"} beheren`} />
            </HorizontalLayout>
            <Search
                className={"department-search"}
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder={`Zoek op ${isPublic ? "doelgroep…" : "afdeling…"}`}
            />
            {loading ? (
                
                <VerticalLayout style={{ justifyContent: "center" }}>
                    <Spinner />
                </VerticalLayout>
            
            ) : (
                <>
                <DepartmentHeaderActions 
                        selectLoader={selectLoader} 
                        toggleAll={toggleAll} 
                        allSelected={allSelected} 
                        selectedCount={selectedCount}
                    />
                <VerticalLayout style={{ maxHeight: "23rem", minHeight: "23rem", overflowY: "auto", padding: "0", width: "auto", marginRight: "1rem"}}>
                    {filteredDepartments.map((department ,index) => (
                        <DepartmentRow
                            key={department.id_department}
                            department={department}
                            onToggle={() => handleToggleDepartment(index, department)}
                        />
                    ))}
                </VerticalLayout>
                </>
            )}
            <ModalButton
                title={"Versturen"}
                style={{ margin: "auto 1rem 1rem 1rem" }}
            />
        </VerticalLayout>
    );
}

const DepartmentRow = ({ department, onToggle }) => (
    <HorizontalLayout className="space-between standard-margin" style={{ width: "auto", paddingRight: 0, marginRight: ".5rem", marginLeft: "1rem" }}>
        <span>{department.name}</span>
        <ToggleSwitch
            className={`department-switch ${department.active ? "active" : ""}`}
            checked={department.active}
            onChange={onToggle}
        />
    </HorizontalLayout>
);

const DepartmentHeaderActions = ({toggleAll, allSelected, selectedCount }) => {
    const userInformation = useContext(UserContext)
    const isPublic = userInformation.account_type === 1
    return(
        <HorizontalLayout className="space-between standard-margin" style={{ width: "auto", marginLeft: !selectedCount ? "auto" : ""}}>
            {selectedCount > 0 && ( <p className="small-text-light"> {selectedCount}{" "}{selectedCount === 1 ? isPublic ? "doelgroep" : "afdeling" : isPublic ? "doelgroepen" : "afdelingen"}{" "}geselecteerd</p>) }
            <ToggleSwitch
                leftTitle={allSelected ? "Deselecteer alles" : "Selecteer alles"}
                className={`department-switch ${allSelected ? "active" : ""}`}
                checked={allSelected}
                onChange={toggleAll}
            />
        </HorizontalLayout>
    )
}
